import { Container, Rectangle } from 'pixi.js';

import { config } from '../config/config';
import Layer from './Layer';
import BulletLayer from './BulletLayer';
import { reverse } from 'ramda';
import { positionsConfig } from '../config/positionsConfig';

export default class LayersContainer extends Container {
  public layers: Layer[];
  public bulletLayers: BulletLayer[];

  constructor() {
    super();

    this.layers = [];
    this.bulletLayers = [];
    this.hitArea = new Rectangle(0, 0, config.SIZES.SCENE_WIDTH, config.SIZES.SCENE_HEIGHT);

    const layersPositionInfo = reverse(positionsConfig);
    const layersDimensions = reverse(config.LAYER_DIMENSIONS);

    let layer;
    layersPositionInfo.forEach((layerData, layerIndex) => {
      layer = new Layer(layerIndex, layerData, layersDimensions[layerIndex]);
      this.addChild(layer);
      this.layers[layerIndex] = layer;
    });

    //create bullet layers above all image layers
    let bulletLayer: BulletLayer;
    this.layers.forEach((layer, layerIndex) => {
      bulletLayer = new BulletLayer(layer.name, layer.size);
      layer.items.forEach((item) => {
        bulletLayer.addChild(item.itemBullet);
      });
      this.addChild(bulletLayer);
      this.bulletLayers[layerIndex] = bulletLayer;
    });

    this.x = -(config.SIZES.SCENE_WIDTH - config.SIZES.MAX_WIDTH) / 2; //??? todo round
    this.y = -(config.SIZES.SCENE_HEIGHT - config.SIZES.MAX_HEIGHT) / 2;
  }
}
